// Collections Hover Mobile Slider Enhancement
(function() {
  'use strict';

  const SELECTORS = {
    hoverTarget: '[data-hover-target]',
    collectionImage: '[data-collection-image]',
    nextButton: '.collections-hover__next-btn',
    currentCounter: '.collections-hover__current',
    progressFill: '.collections-hover__progress-fill',
    detail: '[data-collection-detail]',
    titleItem: '.collections-hover__title-item'
  };

  const CLASSES = {
    visible: 'is-visible',
    selected: 'is-selected', 
    active: 'is-active'
  };

  const ATTRIBUTES = {
    hoverTarget: 'data-hover-target',
    contentTarget: 'data-content-target'
  };

  class CollectionsHoverMobile extends HTMLElement {
    constructor() {
      super();
      this.buttons = this.querySelectorAll(SELECTORS.hoverTarget);
      this.currentIndex = 0;
      this.totalSlides = this.buttons.length;
      this.isMobile = false;
      
      this.checkMobile();
      this.initMobileSlider();
      this.bindEvents();
    }

    checkMobile() {
      this.isMobile = window.innerWidth <= 749;
    }

    bindEvents() {
      // Desktop hover functionality
      this.buttons.forEach(button => {
        button.addEventListener('mouseenter', (e) => {
          if (!this.isMobile) {
            const targetId = e.currentTarget.getAttribute(ATTRIBUTES.hoverTarget);
            const contentId = e.currentTarget.getAttribute(ATTRIBUTES.contentTarget);
            this.updateState(targetId, contentId);
          }
        });
      });

      // Mobile next button
      const nextButton = this.querySelector(SELECTORS.nextButton);
      if (nextButton) {
        nextButton.addEventListener('click', () => {
          if (this.isMobile) {
            this.nextSlide();
          }
        });
      }

      // Window resize handler
      window.addEventListener('resize', () => {
        this.checkMobile();
        if (this.isMobile) {
          this.updateMobileUI();
        }
      });
    }

    initMobileSlider() {
      if (this.isMobile && this.totalSlides > 0) {
        // Initialize first slide
        const firstButton = this.buttons[0];
        if (firstButton) {
          const targetId = firstButton.getAttribute(ATTRIBUTES.hoverTarget);
          const contentId = firstButton.getAttribute(ATTRIBUTES.contentTarget);
          this.updateState(targetId, contentId);
        }
        this.updateMobileUI();
      }
    }

    nextSlide() {
      this.currentIndex = (this.currentIndex + 1) % this.totalSlides;
      
      const currentButton = this.buttons[this.currentIndex];
      if (currentButton) {
        const targetId = currentButton.getAttribute(ATTRIBUTES.hoverTarget);
        const contentId = currentButton.getAttribute(ATTRIBUTES.contentTarget);
        this.updateState(targetId, contentId);
      }
      
      this.updateMobileUI();
    }

    updateMobileUI() {
      if (!this.isMobile) return;

      // Update counter
      const currentCounter = this.querySelector(SELECTORS.currentCounter);
      if (currentCounter) {
        const currentNumber = String(this.currentIndex + 1).padStart(2, '0');
        currentCounter.textContent = currentNumber;
      }

      // Update progress bar
      const progressFill = this.querySelector(SELECTORS.progressFill);
      if (progressFill) {
        const progressPercentage = ((this.currentIndex + 1) / this.totalSlides) * 100;
        progressFill.style.width = `${progressPercentage}%`;
      }

      // Update title display
      const titleItems = this.querySelectorAll(SELECTORS.titleItem);
      titleItems.forEach((titleItem, index) => {
        if (index === this.currentIndex) {
          titleItem.classList.add(CLASSES.active);
        } else {
          titleItem.classList.remove(CLASSES.active);
        }
      });
    }

    updateState(targetId, contentId) {
      const targetButton = this.querySelector(`[${ATTRIBUTES.hoverTarget}="${targetId}"]`);
      const targetImage = this.querySelector(`#${targetId}:not(.${CLASSES.visible})`);
      const currentSelectedButton = this.querySelector(`${SELECTORS.hoverTarget}.${CLASSES.selected}`);
      const currentVisibleImage = this.querySelector(`${SELECTORS.collectionImage}.${CLASSES.visible}`);
      const targetContent = this.querySelector(`#${contentId}`);
      const currentActiveDetail = this.querySelector(`${SELECTORS.detail}.${CLASSES.active}`);

      if (targetImage) {
        // Remove current states
        if (currentVisibleImage) {
          currentVisibleImage.classList.remove(CLASSES.visible);
        }
        if (currentSelectedButton) {
          currentSelectedButton.classList.remove(CLASSES.selected);
        }
        if (currentActiveDetail) {
          currentActiveDetail.classList.remove(CLASSES.active);
        }

        // Add new states
        targetImage.classList.add(CLASSES.visible);
        if (targetButton) {
          targetButton.classList.add(CLASSES.selected);
        }
        if (targetContent) {
          targetContent.classList.add(CLASSES.active);
        }
      }
    }
  }

  // Register the custom element
  if (!customElements.get('collections-hover')) {
    customElements.define('collections-hover', CollectionsHoverMobile);
  }

})();